<template>
	<div class="page">
		<div class="page-inner centered-content">
			<div class="loading">Loading...</div>
		</div>
	</div>
</template>

<script>
export default {
	async created() {
		let tracklist = null;
		let tracklistJSON = localStorage.getItem('tracklist');
		if (tracklistJSON) tracklist = JSON.parse(tracklistJSON);

		let playlistName = localStorage.getItem('playlistName');
		let playlistDescription = localStorage.getItem('playlistDescription');

		if (!Array.isArray(tracklist) || !playlistName || !playlistDescription) {
			this.$router.replace('/');
			return;
		}

		await this.createPlaylist(playlistName, playlistDescription, tracklist);
	},
	methods: {
		async createPlaylist(playlistName, playlistDescription, trackIDs) {
			try {
				let res = await axios.post('/spotify/playlist/create', {
					playlist_name: playlistName,
					playlist_description: playlistDescription,
					track_ids: trackIDs
				});
				console.log(res.data);

				let userID = res.data.user_id;
				let playlistID = res.data.playlist_id;

				window.location.replace(`https://open.spotify.com/user/${userID}/playlist/${playlistID}`);
			} catch (err) {
				console.error(err);
				if (err.response) {
					console.error(err.response.data);
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
};
</script>

<style scoped>
	.loading {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 3rem;
		font-family: 'Seek Regular';
	}
</style>
